(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  /* --- Sort by (Shopify native) --- */
  const sortSel  = document.getElementById('SortBy');
  const grid     = document.querySelector('.jm-grid');
  const alphaBar = document.querySelector('.jm-alpha');
  if (!grid || !alphaBar) return;

  const cells     = Array.from(grid.querySelectorAll('.jm-cell'));
  const alphaBtns = Array.from(alphaBar.querySelectorAll('.jm-alpha__btn'));

  /** アルファベットフィルタ（このページ内の商品だけ） **/
  const applyFilter = (letter = 'ALL') => {
    const isAll = letter === 'ALL';
    cells.forEach(li => {
      const first = (li.dataset.firstLetter || '').toUpperCase();
      li.style.display = (isAll || first === letter) ? '' : 'none';
    });
  };

  /* --- アルファベットボタン --- */
  alphaBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      alphaBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const letter = (btn.dataset.letter || 'ALL').toUpperCase();
      applyFilter(letter);

      // sort 後も同じ文字でフィルタを復元するため保存
      sessionStorage.setItem('alphaLetter', letter);
    });
  });

  /* --- Sort by：Shopify 標準＋アルファベット選択の維持 --- */
  if (sortSel) {
    sortSel.addEventListener('change', function() {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);

      const activeBtn = alphaBtns.find(b => b.classList.contains('is-active'));
      const letter = activeBtn ? (activeBtn.dataset.letter || 'ALL').toUpperCase() : 'ALL';
      sessionStorage.setItem('alphaLetter', letter);

      window.location.href = url.toString();
    });
  }

  /* --- ページ読み込み時にアルファベット選択を復元 --- */
  let savedLetter = (sessionStorage.getItem('alphaLetter') || 'ALL').toUpperCase();

  // このコレクションに存在しないボタンが保存されていたら ALL に戻す
  const availableLetters = alphaBtns.map(b => (b.dataset.letter || 'ALL').toUpperCase());
  if (!availableLetters.includes(savedLetter)) {
    savedLetter = 'ALL';
  }

  applyFilter(savedLetter);

  alphaBtns.forEach(btn => {
    const letter = (btn.dataset.letter || 'ALL').toUpperCase();
    const isActive = (savedLetter === 'ALL' && letter === 'ALL') || letter === savedLetter;
    btn.classList.toggle('is-active', isActive);
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.featured-collection-wrapper');

  sections.forEach(function(section) {
    const header       = section.querySelector('.collection-header');
    const container    = section.querySelector('ul.grid--view-items');
    const alphaButtons = section.querySelectorAll('.alpha-btn');
    const showMoreBtn  = section.querySelector('.show-more-btn');
    const sortButtons  = header ? header.querySelectorAll('.sort-btn') : [];

    if (!container) return;

    // すべての li を「元データ」として保持
    let allItems = Array.from(container.querySelectorAll('li'));

    // 初期情報
    allItems.forEach(function(item, idx) {
      item.dataset.originIndex = String(idx);

      if (!item.dataset.clicks) {
        item.dataset.clicks = '0';
      }

      const dateMs = new Date(item.dataset.date || 0).getTime();
      item.dataset.dateMs = String(isNaN(dateMs) ? 0 : dateMs);
    });

    let currentSort   = 'highlighted';
    let currentLetter = 'all';
    let expanded      = false;
    const baseLimit   = 25;   // ★ここを10にすれば「各文字10件まで」に変更可能

    // 並び替え：allItems 自体の順番を変える
    function sortItems() {
      let sorted = allItems.slice();

      if (currentSort === 'highlighted') {
        sorted.sort(function(a, b) {
          const ac = parseInt(a.dataset.clicks, 10) || 0;
          const bc = parseInt(b.dataset.clicks, 10) || 0;
          if (bc !== ac) return bc - ac;
          return parseInt(a.dataset.originIndex, 10) - parseInt(b.dataset.originIndex, 10);
        });
      } else { // newest
        sorted.sort(function(a, b) {
          const ad = parseInt(a.dataset.dateMs, 10) || 0;
          const bd = parseInt(b.dataset.dateMs, 10) || 0;
          if (bd !== ad) return bd - ad;
          return parseInt(a.dataset.originIndex, 10) - parseInt(b.dataset.originIndex, 10);
        });
      }

      allItems = sorted;
    }

    // タイトルから「最初に出てくる A〜Z」を1文字取る
    function getFirstLetterFromTitle(item) {
      const titleEl = item.querySelector('.grid-view-item__title');
      const raw     = (titleEl ? titleEl.textContent : '').trim().toUpperCase();
      if (!raw) return '';

      const match = raw.match(/[A-Z]/); // A〜Z の最初の1文字
      return match ? match[0] : '';
    }

    // フィルタ＋UL再構築
    function applyFilterAndRender() {
      const letterUpper = currentLetter.toUpperCase();

      const filtered = allItems.filter(function(item) {
        if (currentLetter === 'all') return true;
        const first = getFirstLetterFromTitle(item);
        return first === letterUpper;
      });

      const maxVisible = expanded
        ? filtered.length
        : Math.min(filtered.length, baseLimit);

      // UL の中身を入れ替え
      container.innerHTML = '';

      filtered.forEach(function(item, index) {
        if (index < maxVisible) {
          item.style.display = '';
          container.appendChild(item);
        }
      });

      // Show More ボタン制御
      if (showMoreBtn) {
        if (filtered.length > baseLimit) {
          showMoreBtn.style.display = '';
          showMoreBtn.textContent   = expanded ? 'Show Less' : 'Show More';
          showMoreBtn.classList.toggle('active', expanded);
        } else {
          showMoreBtn.style.display = 'none';
        }
      }
    }

    // ソートボタン
    if (sortButtons.length) {
      sortButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          sortButtons.forEach(function(b) { b.classList.remove('active'); });
          btn.classList.add('active');

          currentSort = btn.dataset.sort || 'highlighted';
          sortItems();
          applyFilterAndRender();
        });
      });
    }

    // アルファベットボタン
    alphaButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        alphaButtons.forEach(function(b) { b.classList.remove('active'); });
        btn.classList.add('active');

        currentLetter = btn.dataset.letter || 'all';
        expanded = false;
        applyFilterAndRender();
      });
    });

    // Show More / Less
    if (showMoreBtn) {
      showMoreBtn.addEventListener('click', function() {
        expanded = !expanded;
        applyFilterAndRender();
      });
    }

    // 初期表示
    sortItems();
    applyFilterAndRender();
  });
});

  } catch(e) { console.error(e); }
})();
})();
